export let numberToString = aNumber => {
    if (aNumber !== undefined) {
        return aNumber.toString();
    } else {
        return null;
    }
};